import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AddDialogData } from 'src/app/page/masterdata/rail-points/rail-points.component';

@Component({
  selector: 'app-add-rail-point',
  templateUrl: './add-rail-point.component.html',
  styleUrls: ['./add-rail-point.component.scss'],
  standalone: false // NOSONAR
})
export class AddRailPointComponent implements OnInit {

  railPointID = "Auto assigned";
  fiscalyear;
  railPointCode;
  location;
  roundTripCost;
  enableError: boolean = false;
  isAdd: boolean = false;

  action;
  heading;
  errormsg: string;

  dynamicHeight: number;

  constructor(private readonly ngxUiLoaderService: NgxUiLoaderService, @Inject(MAT_DIALOG_DATA) public dataStore: AddDialogData,
    private readonly dialogRef: MatDialogRef<AddRailPointComponent>) {

    this.dynamicHeight = 0.665 * (window.innerHeight);
    this.ngxUiLoaderService.start("loader-01");

    this.ngxUiLoaderService.stop("loader-01");

    if (this.dataStore.performAction == 'EditCell') { // NOSONAR
      this.heading = "Edit";
      this.action = 'EditCell';

      this.railPointID = this.dataStore.placeholder_railPointID;
      this.railPointCode = this.dataStore.placeholder_railPointCode;
      this.location = this.dataStore.placeholder_location;
      this.roundTripCost = this.dataStore.placeholder_roundTripCost;
    }
    else {
      this.fiscalyear = this.dataStore.placeholder_fiscalYear;
      this.heading = "Add";
      this.action = 'AddCell';
      this.isAdd = true;
    }
  }

  ngOnInit(): void { // NOSONAR 

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  close(): void {
    this.dialogRef.close();
  }

  public saveClick() {
    debugger
    console.info("Rail Point Id", this.railPointID);
    console.info("Rail Point Code", this.railPointCode);
    console.info("Location", this.location);
    console.info("Round Trip Cost", this.roundTripCost);

    if (this.isAdd) {

      if (this.railPointCode == '' || this.railPointCode == null || this.railPointCode == undefined || this.railPointCode.trim().length == 0 || this.location == null || this.location == undefined || this.roundTripCost == null || this.roundTripCost == undefined) {// NOSONAR
        this.enableError = true;
        this.errormsg = 'Please fill in the required fields!';
      }
      else if (!this.railPointCode || this.railPointCode.trim().length < 5 || this.railPointCode.trim().length > 8) {
        this.enableError = true;
        this.errormsg = 'Rail Point Code must be between 5 and 8 characters.';
        return;
      }
      else {
        this.dialogRef.close({
          event: this.action, data0: this.railPointID, data1: this.fiscalyear,
          data2: this.railPointCode, data3: this.location, data4: this.roundTripCost
        });
      }
    } else if (this.location == null || this.location == undefined || this.roundTripCost == null || this.roundTripCost == undefined) { // NOSONAR
      this.enableError = true;
      this.errormsg = 'Please fill in the required fields!';
    }
    else {
      this.dialogRef.close({
        event: this.action, data0: this.railPointID, data1: this.location, data2: this.roundTripCost
      });
    }
  }
}

